<template>
  <div class="home">
    <TopBar :scenename="scenename"></TopBar>
    <div class="downcontent">
      <LeftBar :hasInfos="hasInfos" :activeIndex="nowActiveIndex"></LeftBar>
      <router-view
        ref="viewLink"
        :panoEditInfos="panoEditInfos"
        :infos="resInfos"
        :nowFloor="nowFloor"
        :resData="resData"
      ></router-view>
    </div>
  </div>
</template>
<style>
.downcontent * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
<style scoped>
.home {
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
  text-align: center;
}
.downcontent {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
}
</style>
<script>
import TopBar from '../components/webgl/TopBar.vue'
import LeftBar from '../components/webgl/LeftBar.vue'
import https from '../https.js'
export default {
  name: '',
  components: {
    TopBar,
    LeftBar
  },
  data() {
    return {
      nowActiveIndex: 'basic',
      //编辑场景统一数据
      panoEditInfos: {
        nowPointActiveIndex: -1,
        nowPanoActiveIndex: 0,
        sandPointActiveIndex: -1
      },
      sceneID: '',
      scenename: '',
      hasInfos: false,
      resInfos: {},
      nowFloor: 0,
      resData: [],
      groupInfos: []
    }
  },
  created() {
    this.nowActiveIndex = this.$route.name
    this.sceneID = this.$route.query.id
    https
      .fetchPost('/api/HotPoint/GetlistByPyFile_Scene_ID_2', {
        sceneID: this.sceneID
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res)
          for (var j = 0; j < res.data.length; j++) {
            const num = j
            var m = {}
            m = res.data[num].scene
            m.model = res.data[num].model
            m.switchs = res.data[num].switchs
            m.panos = []
            for (var i = 0; i < res.data[num].result.length; i++) {
              var k = {}
              k.physicalFile = res.data[num].result[i].physicalFile
              k.hotPointlist = res.data[num].result[i].hotPointlist
              for (var key in res.data[num].result[i].physicalFile_Scene) {
                k[key] = res.data[num].result[i].physicalFile_Scene[key]
              }
              k.audioSrc = res.data[num].result[i].audioSrc
              k.musicInfo = res.data[num].result[i].musicInfo
              m.panos.push(k)
            }
            m.sandTable_Point = res.data[num].sandTable_Point
            if (m.sandTable_Point.sandPoints == null) {
              m.sandTable_Point.sandPoints = []
            }
            this.resData.push(m)
          }

          this.resInfos = this.resData[this.nowFloor]
          console.log(this.resInfos)
          this.scenename = this.resInfos.sceneName
          this.hasInfos = true
        }
      })
  },
  methods: {
    changePanoEditInfos(prop, val) {
      this.panoEditInfos[prop] = val
    },
    saveData() {
      const totalData = []
      for (var j = 0; j < this.resData.length; j++) {
        var data = {}
        data.scene = {}
        const resInfos = this.resData[j]
        for (var key in resInfos) {
          if (key !== 'model' && key !== 'panos' && key !== 'switchs') {
            data.scene[key] = resInfos[key]
          }
        }
        if (resInfos.model != null) {
          data.model = resInfos.model
        } else {
          data.model = {}
        }
        data.sandTable_Point = data.scene.sandTable_Point
        data.result = []
        for (var i = 0; i < resInfos.panos.length; i++) {
          var m = {}
          m.physicalFile_Scene = {}
          for (var key1 in resInfos.panos[i]) {
            if (key1 !== 'hotPointlist' && key1 !== 'physicalFile') {
              m.physicalFile_Scene[key1] = resInfos.panos[i][key1]
            }
          }
          m.hotPointlist = resInfos.panos[i].hotPointlist
          m.physicalFile = resInfos.panos[i].physicalFile
          m.audioSrc = resInfos.panos[i].audioSrc
          m.musicInfo = resInfos.panos[i].musicInfo
          data.result.push(m)
        }
        var switchs = resInfos.switchs
        data.switchs = switchs
        totalData.push(data)
      }

      const totalData2 = []
      for (var j = 0; j < this.groupInfos.length; j++) {
        var data = {}
        data.scene = {}
        const resInfos = this.groupInfos[j]
        for (var key in resInfos) {
          if (key !== 'model' && key !== 'panos' && key !== 'switchs') {
            data.scene[key] = resInfos[key]
          }
        }
        if (resInfos.model != null) {
          data.model = resInfos.model
        } else {
          data.model = {}
        }
        data.sandTable_Point = data.scene.sandTable_Point
        data.result = []
        for (var i = 0; i < resInfos.panos.length; i++) {
          var m = {}
          m.physicalFile_Scene = {}
          for (var key1 in resInfos.panos[i]) {
            if (key1 !== 'hotPointlist' && key1 !== 'physicalFile') {
              m.physicalFile_Scene[key1] = resInfos.panos[i][key1]
            }
          }
          m.hotPointlist = resInfos.panos[i].hotPointlist
          m.physicalFile = resInfos.panos[i].physicalFile
          m.audioSrc = resInfos.panos[i].audioSrc
          m.musicInfo = resInfos.panos[i].musicInfo
          data.result.push(m)
        }
        var switchs = resInfos.switchs
        data.switchs = switchs
        totalData2.push(data)
      }
      console.log(totalData)
      console.log(totalData2)
      https
        .fetchPost('/api/HotPoint/UpdateScenes', {
          updateScene: totalData,
          deleteInfo: totalData2
        })
        .then((res) => {
          console.log(res)
          if (res.data.message === '成功') {
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
          }
        })
    },
    changeResInfo(now) {
      console.log(now)
      this.nowFloor = now
    },
    changeRes(i) {
      this.nowFloor = 0
      this.$refs.viewLink.changePanoMatByFloor(0, 0)
      const json = this.resData.splice(i, 1)
      if (json[0].id != '00000000-0000-0000-0000-000000000000') {
        this.groupInfos.push(json[0])
      }
      console.log(this.groupInfos)
    },
    changeRes2(i) {
      const json = this.resData.splice(i, 1)
      if (json[0].id != '00000000-0000-0000-0000-000000000000') {
        this.groupInfos.push(json[0])
      }
      console.log(this.groupInfos)
    },
    goweb(str) {
      this.nowActiveIndex = str.toLowerCase()
      // this.$router.push({ name: str, params: { id: this.sceneID } })
      this.$router.push(str + '?id=' + this.sceneID)
    },
    preView() {
      this.$router.push(
        '/' +
          (this.resInfos.isModelShow ? 'preview' : 'previewwidthoutmodel') +
          '?id=' +
          this.sceneID
      )
    }
  },
  mounted() {}
}
</script>
